import React from 'react';
import { ButtonStyle } from '../../../../styles';
import { useModal } from '../../../../../../../../hooks/Modal';
import Paginas from '../../../../../../../../PagesApplication/HomeApplication/modules/Paginas';
import { SubTitleStyle, ParagraphStyle } from '../../styles';
import { string } from 'yup';
import { urlWebsite } from 'src/config';

interface IProps {
    computerStyle: Record<string, any>;
    mobileStyle: Record<string, any>;
    content: Array<Record<string, any>>;
}

const ButtonsDisplay: React.FC<IProps> = ({ content, computerStyle = {}, mobileStyle = {} }) => {

    const { addModal } = useModal();

    const openPopup = (contentInfo) => {
        addModal({
            title: '', content: <>
                {contentInfo?.content_title ? <><SubTitleStyle computer={computerStyle} mobile={mobileStyle}>{contentInfo?.content_title}</SubTitleStyle> <br /></> : <></>}
                {contentInfo?.content_description ? <ParagraphStyle computer={computerStyle} mobile={mobileStyle} dangerouslySetInnerHTML={{ __html: contentInfo?.content_description }} /> : <></>}

                {contentInfo?.content_buttons ? <div className='row gap-sm' style={{ flexWrap: 'wrap' }}>

                    {contentInfo?.content_buttons?.map(buttonInfo => {
                        return <div className='row gap-sm' style={{ flexWrap: 'wrap' }}>
                            {buttonInfo?.type === 'external' ? <a onClick={() => { window?.scrollTo(0, 0) }} href={buttonInfo?.url} target="_blank"><ButtonStyle style={{ margin: '0px' }} className={buttonInfo?.className ? buttonInfo?.className : ` greenButton2 shadow`} computer={computerStyle} mobile={mobileStyle}>{buttonInfo?.image ? <img style={{ width: buttonInfo?.image_size || '30px' }} src={`${urlWebsite}/${buttonInfo?.image}`} /> : <></>}{buttonInfo?.title}</ButtonStyle></a> : <></>}

                            {buttonInfo?.type === 'internal' ? <a onClick={() => { window?.scrollTo(0, 0) }} href={buttonInfo?.url}><ButtonStyle style={{ margin: '0px' }} className={buttonInfo?.className ? buttonInfo?.className : ` greenButton2 shadow`} computer={computerStyle} mobile={mobileStyle}>{buttonInfo?.image ? <img style={{ width: buttonInfo?.image_size || '30px' }} src={`${urlWebsite}/${buttonInfo?.image}`} /> : <></>} {buttonInfo?.title}</ButtonStyle></a> : <></>}

                        </div>

                    })}

                </div> : <></>}

                {contentInfo?.content_hash ? <Paginas hash={contentInfo?.content_hash} project_id={contentInfo?.content_project_id} /> : <></>}


            </>, theme: 'whiteModalMedium'
        });
    }

    return <>
        {content?.map(buttonInfo => {

            const computer = {
                ...computerStyle,
                color: buttonInfo?.color || computerStyle?.color,
                background: buttonInfo?.background || computerStyle?.background,
                padding: buttonInfo?.padding || computerStyle?.padding,
                'border-radius': buttonInfo?.['border-radius'] || computerStyle?.['border-radius'],
                'border': buttonInfo?.['border'] || computerStyle?.['border'],

                'font-size': buttonInfo?.color || computerStyle?.['font-size'],
            };

            const mobile = {
                ...mobileStyle,
                color: buttonInfo?.color || mobileStyle?.color,
                background: buttonInfo?.background || mobileStyle?.background,
                padding: buttonInfo?.padding || mobileStyle?.padding,
                'border-radius': buttonInfo?.['border-radius'] || mobileStyle?.['border-radius'],
                'border': buttonInfo?.['border'] || mobileStyle?.['border'],
                'font-size': buttonInfo?.color || mobileStyle?.['font-size'],
            };

            return <div className=' gap-sm' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                {buttonInfo?.type === 'external' ? <a onClick={() => { window?.scrollTo(0, 0) }} href={buttonInfo?.url} target="_blank"><ButtonStyle style={{ margin: '0px' }} className={buttonInfo?.className ? buttonInfo?.className : ` greenButton2 shadow`} computer={{ ...computer, "flex-direction": 'row' }} mobile={{ ...mobile, "flex-direction": 'row' }}>{buttonInfo?.image ? <img style={{ width: buttonInfo?.image_size || '30px' }} src={`${urlWebsite}/${buttonInfo?.image}`} /> : <></>}{buttonInfo?.title}</ButtonStyle></a> : <></>}

                {buttonInfo?.type === 'internal' ? <a onClick={() => { window?.scrollTo(0, 0) }} href={buttonInfo?.url}><ButtonStyle style={{ margin: '0px' }} className={buttonInfo?.className ? buttonInfo?.className : ` greenButton2 shadow`} computer={{ ...computer, "flex-direction": 'row' }} mobile={{ ...mobile, "flex-direction": 'row' }}>{buttonInfo?.image ? <img style={{ width: buttonInfo?.image_size || '30px' }} src={`${urlWebsite}/${buttonInfo?.image}`} /> : <></>}{buttonInfo?.title}</ButtonStyle></a> : <></>}
                {buttonInfo?.type === 'popup' ? <ButtonStyle onClick={() => openPopup(buttonInfo)} style={{ margin: '0px' }} className={buttonInfo?.className ? buttonInfo?.className : ` greenButton2 shadow`} computer={computer} mobile={mobile}>{buttonInfo?.image ? <img style={{ width: buttonInfo?.image_size || '30px' }} src={`${urlWebsite}/${buttonInfo?.image}`} /> : <></>}{buttonInfo?.title}</ButtonStyle> : <></>}
            </div>
        })}
    </>


}

export default ButtonsDisplay;